import React from 'react';
import { Link } from 'react-router-dom';
import { MessagesSquare, DraftingCompass, Cog, Hammer, Wrench, ClipboardCheck, Truck, Power, GraduationCap, Headphones, ArrowRight } from 'lucide-react';

const steps = [
  { icon: MessagesSquare, title: 'Consultation' },
  { icon: DraftingCompass, title: 'Plant Design' },
  { icon: Cog, title: 'Engineering' },
  { icon: Hammer, title: 'Fabrication' },
  { icon: Wrench, title: 'Assembly' },
  { icon: ClipboardCheck, title: 'Testing' },
  { icon: Truck, title: 'Installation' },
  { icon: Power, title: 'Commissioning' },
  { icon: GraduationCap, title: 'Training' },
  { icon: Headphones, title: 'After-Sales Support' }
];

export const ProcessTimelineSection = () => (
  <section className="py-16 md:py-20 bg-gray-50" data-testid="process-timeline-section">
    <div className="container mx-auto px-4">
      <div className="text-center mb-12">
        <div className="text-sm font-bold text-alden-green uppercase tracking-widest mb-2">Turnkey Project Process</div>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900">From Enquiry to Running Plant</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-4">
        {steps.map((s, idx) => (
          <div key={s.title} className="relative bg-white border border-gray-200 rounded-xl p-5 text-center hover:border-alden-green hover:shadow-lg transition-all" data-testid={`process-step-${idx + 1}`}>
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-alden-green text-white text-xs font-bold w-7 h-7 rounded-full flex items-center justify-center">
              {idx + 1}
            </div>
            <s.icon className="w-8 h-8 text-alden-green mx-auto mt-2 mb-3" />
            <div className="font-semibold text-gray-900 text-sm">{s.title}</div>
          </div>
        ))}
      </div>
      <div className="text-center mt-10">
        <Link to="/process" className="inline-flex items-center gap-2 text-alden-green font-semibold hover:underline">
          See the complete project process <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  </section>
);

export default ProcessTimelineSection;
